<template>
  <v-dialog v-model="dialog" width="500" scrollable>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <add-button v-if="!id"></add-button>
        <edit-icon-button v-else></edit-icon-button>
      </div>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            label="Group Name"
            v-model="form.name"
            outlined
            :rules="rules"
            dense
          ></v-text-field>
          <v-autocomplete
            label="Technicians"
            multiple
            v-model="form.users"
            outlined
            item-text="name"
            item-value="value"
            :items="users"
            :rules="rules"
            dense
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-5">
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" v-if="isAdmin" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDate } from "../../../assets/js/common";
import { technicianGroups } from "../../../assets/js/firebase";
import { FIELD } from "../../../assets/js/rules";
import AddButton from "../../buttons/AddButton.vue";
import EditIconButton from "../../buttons/EditIconButton.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { AddButton, EditIconButton },
  data() {
    return {
      dialog: false,
      isValid: false,
      rules: FIELD,
      form: {
        name: "",
        users: []
      }
    };
  },
  computed: {
    title() {
      return this.id ? "Update Group" : "Add New Group";
    },
    id() {
      return this.item.id;
    },
    users() {
      return this.$store.getters.technicians.map(item => {
        let name = item.first_name + " " + item.last_name;
        return { name: name, value: item.id };
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let lower = vm.form.name.toLowerCase();
      let updated_at = getDate();
      let doc = { lower, updated_at };
      Object.keys(vm.form).forEach(key => {
        doc[key] = vm.form[key];
      });
      if (vm.id) {
        vm.update(doc);
      } else {
        vm.create(doc);
      }
    },
    async create(doc) {
      const vm = this;
      vm.$root.loader = true;
      try {
        let snap = await technicianGroups
          .where("lower", "==", doc.lower)
          .limit(1)
          .get();
        if (!snap.empty) {
          vm.$root.loader = false;
          vm.$root.alert(
            "Another technician group already exists with the same name. Please enter a unique name."
          );
          return;
        }
        doc.created_at = getDate();
        doc.type = "global";
        await technicianGroups.add(doc);
        vm.form = {
          name: "",
          users: []
        };
        vm.dialog = false;
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    async update(doc) {
      const vm = this;
      vm.$root.loader = true;
      try {
        let snap = await technicianGroups
          .where("lower", "==", doc.lower)
          .limit(1)
          .get();
        if (!snap.empty && snap.docs[0].id != vm.id) {
          vm.$root.loader = false;
          vm.$root.alert(
            "Another technician group already exists with the same name. Please enter a unique name."
          );
          return;
        }
        await technicianGroups.doc(vm.id).update(doc);
        vm.form = {
          name: "",
          users: []
        };
        vm.dialog = false;
        vm.$root.loader = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
    init() {
      const vm = this;
      if (vm.id) {
        Object.keys(vm.form).forEach(key => {
          vm.form[key] = vm.item[key];
        });
      }
    }
  }
};
</script>

<style></style>
